<button class="provider-button" (click)="onButtonClick()">
	@if (iconSrc) {
		<img alt="{{ ssoProvider }} icon" class="logo" [src]="iconSrc" />
	} @else {
		<div class="placeholder"></div>
	}

	<p innerHTML="{{ 'ssoLandingPage.buttonText' | translate: { sso: ssoProvider } }}"></p>
</button>
